/**
 * De dónde salió el hint de duplicado de una carta. Una sola definición para el mazo (que lo
 * calcula), la carta y la lista de la Memoria (que lo pintan): tres copias del literal `'update'`
 * eran tres lugares donde un cambio de valor dejaba las vistas diciendo «Posible duplicado» sin
 * que nada fallara (review 2026-09-05, C-memoria-46).
 */
export const HINT_UPDATE = 'update';       // el backend señaló `update_of_id`: «Cambió»
export const HINT_LOOKALIKE = 'lookalike'; // parecido léxico con la biblioteca: «Posible duplicado»
